<template>
  <SelectSequenceOwner
    :model-value="transformedValue"
    :is-display-only="props.isDisplayOnly"
    @update:model-value="handleUpdate"
  />
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue';
import SelectSequenceOwner, { TSequenceOwnerValue as TSequenceOwnerValueOriginal } from '@/components/organisms/user/general/sequence/SelectSequenceOwner.vue';

export type TSequenceOwnerValue = number | 'lead_owner' | 'sequence_owner' | undefined;

type TProps = {
  isDisplayOnly?: boolean;
};

const props = withDefaults(defineProps<TProps>(), {
  isDisplayOnly: false,
});

const model = defineModel<TSequenceOwnerValue>();

const transformedValue = computed(() => {
  if (model.value === 'lead_owner') return 'leadOwner';
  if (model.value === 'sequence_owner') return 'sequenceOwner';
  return model.value as number | null;
});

const handleUpdate = (value: TSequenceOwnerValueOriginal) => {
  const mapping = {
    leadOwner: 'lead_owner',
    sequenceOwner: 'sequence_owner',
  };
  model.value = mapping[value] || value;
};

onMounted(() => {
  if (model.value == null) {
    model.value = 'sequence_owner';
  }
});
</script>
